/** Korean copy for the shared public SEO shell. Product/editor copy falls back to English. */
export const ko = {
  common: {
    loading: '불러오는 중...',
    error: '오류',
    retry: '다시 시도',
    signIn: '로그인',
    signUp: '회원가입',
  },
  landing_v3: {
    nav: {
      use_case: '활용 사례',
      pricing: '요금제',
      log_in: '로그인',
      start_free: '무료로 시작',
      workspace: '워크스페이스',
      toggle_menu_aria: '메뉴 열기',
      close_menu_aria: '메뉴 닫기',
    },
    footer: {
      group_design_tools: '디자인 도구',
      group_company: '회사',
      group_resources: '리소스',
      group_connect: '소셜',
      company: {
        about: '회사 소개',
        contact: '문의하기',
        terms: '이용약관',
        privacy: '개인정보 처리방침',
        cookie_policy: '쿠키 정책',
      },
      resources: {
        help: '도움말',
        solutions: '솔루션',
        tools: '도구',
        learn: '학습 센터',
        blog: '블로그',
        spotlight: '스포트라이트',
      },
    },
  },
  landing_home: {
    nav: {
      logo_alt: 'Veeso AI',
      features: '기능',
      pricing: '요금제',
      about: '회사 소개',
      spotlight: '스포트라이트',
      start_free: '무료로 시작',
      workspace: '워크스페이스',
      toggle_menu_aria: '메뉴 열기',
      close_menu_aria: '메뉴 닫기',
    },
    footer: {
      sr_only: '푸터',
      col: {
        design_tools: '디자인 도구',
        resources: '리소스',
        company: '회사',
        connect: '소셜',
      },
      link: {
        help: '도움말',
        solutions: '솔루션',
        tools: '도구',
        learn: '학습 센터',
        blog: '블로그',
        spotlight: '스포트라이트',
        changelog: '변경 내역',
        affiliates: '파트너',
        about: '회사 소개',
        contact: '문의하기',
        terms: '이용약관',
        privacy: '개인정보 처리방침',
        cookie_policy: '쿠키 정책',
        x: 'X',
        linkedin: 'LinkedIn',
        discord: 'Discord',
      },
      tooltip: {
        coming_soon: '곧 제공 예정',
      },
      copyright: '© {{year}} Veeso AI.',
    },
  },
  landingPages: {
    auth: {
      loggedIn: {
        goToWorkspace: '워크스페이스로 이동',
      },
    },
    articleDetail: {
      breadcrumb: {
        home: '홈',
      },
      toc: {
        title: '목차',
      },
      meta: {
        min_read: '약 {{count}}분',
        last_updated: '최근 업데이트:',
        author: 'Veeso 팀',
      },
      faq: {
        title: '자주 묻는 질문',
        subtitle: '알아두면 좋은 내용을 확인하세요.',
      },
      share: {
        twitter: 'X에 공유',
        linkedin: 'LinkedIn에 공유',
        facebook: 'Facebook에 공유',
        discord: 'Discord 참여',
        aria_twitter: 'X에 공유',
        aria_linkedin: 'LinkedIn에 공유',
        aria_facebook: 'Facebook에 공유',
        aria_discord: 'Discord 참여',
      },
      recommended: {
        title: '추천 콘텐츠',
        see_all: '전체 보기',
      },
      cta: {
        title_line1: '지금 Veeso AI로',
        title_line2: '디자인을 시작하세요.',
        signup: '무료로 시작',
      },
      seo_description_fallback: 'Veeso 블로그에서 자세히 알아보세요.',
    },
    blog: {
      index: {
        hero: {
          title: 'Veeso 블로그',
          subtitle: 'AI 디자인 인사이트, 튜토리얼, 실무 가이드를 만나보세요.',
        },
        seo: {
          title: 'Veeso 블로그 | AI 디자인 인사이트와 가이드',
          description:
            'AI 디자인, 콘텐츠 제작, 마케팅 워크플로에 관한 인사이트와 실무 가이드를 확인하세요.',
          page_title: '{{title}} - {{page}}페이지 | Veeso',
        },
        faq: {
          title: '자주 묻는 질문',
          items: [
            {
              question: 'Veeso 학습 및 블로그에서는 어떤 주제를 다루나요?',
              answer:
                'AI 디자인 모범 사례, 콘텐츠 제작 전략, 마케팅 팁, 디자인 튜토리얼, 사례 연구, Veeso AI 활용법 등 다양한 주제를 다룹니다. 더 나은 디자인과 효율적인 워크플로를 만드는 데 도움이 되는 글을 정기적으로 발행합니다.',
            },
            {
              question: '새 글은 얼마나 자주 게시되나요?',
              answer:
                'AI 디자인의 최신 흐름과 실무 팁을 전하기 위해 새 글을 정기적으로 게시합니다. 새 콘텐츠를 확인하려면 이 페이지를 다시 방문하거나 Veeso 채널을 팔로우해 주세요.',
            },
            {
              question: '향후 블로그 주제를 제안할 수 있나요?',
              answer:
                '네. 다뤄 주었으면 하는 주제가 있다면 문의 페이지나 소셜 미디어 채널을 통해 의견을 보내 주세요.',
            },
            {
              question: '튜토리얼은 초보자에게도 적합한가요?',
              answer:
                '네. 처음 시작하는 분부터 숙련된 디자이너까지 활용할 수 있도록 단계별 안내와 명확한 설명을 제공합니다.',
            },
            {
              question: '학습 및 블로그 글을 다른 사람과 공유해도 되나요?',
              answer:
                '네. 소셜 미디어나 팀 채널에서 자유롭게 공유할 수 있으며, 각 글에서 제공하는 공유 기능을 이용할 수 있습니다.',
            },
            {
              question: '글에 실무 예시도 포함되나요?',
              answer:
                '네. 실제 프로젝트에 바로 적용할 수 있는 사례, 활용 예시, 실무 팁을 포함하며 이론보다 실행 가능한 인사이트에 초점을 맞춥니다.',
            },
            {
              question: '새 블로그 글 소식은 어떻게 확인할 수 있나요?',
              answer:
                '학습 및 블로그 페이지를 정기적으로 방문하거나 새 글을 안내하는 Veeso 소셜 미디어 채널을 팔로우해 주세요. 빠르게 다시 찾을 수 있도록 페이지를 북마크해 두는 것도 좋습니다.',
            },
            {
              question: '동영상 튜토리얼도 제공되나요?',
              answer:
                '블로그는 주로 글과 단계별 튜토리얼을 제공하지만, 일부 글에는 동영상이나 관련 영상 자료 링크가 포함될 수 있습니다.',
            },
            {
              question: '글에 나온 디자인 예시를 내 프로젝트에 활용해도 되나요?',
              answer:
                '네. 글에서 소개하는 예시와 템플릿은 아이디어와 제작 방향을 돕기 위한 자료입니다. 프로젝트 목적에 맞게 개념과 아이디어를 응용할 수 있습니다.',
            },
            {
              question: '특정 주제의 글은 어떻게 찾나요?',
              answer:
                '학습 및 블로그 페이지에서 최신 글을 둘러보고, 제공되는 경우 검색 기능이나 카테고리 태그를 사용해 원하는 주제를 찾을 수 있습니다.',
            },
          ],
        },
        pagination: {
          prev: '← 이전',
          next: '다음 →',
          prev_aria: '이전 페이지로 이동',
          next_aria: '다음 페이지로 이동',
        },
        card: {
          read_more: '더 읽기',
        },
        author_alt_fallback: '작성자',
        image_alt_fallback: '블로그 게시물 이미지',
        empty_state: '아직 게시물이 없습니다. 곧 다시 확인해 주세요.',
        min_read: '약 {{count}}분',
        showing_posts: '전체 {{total}}개 중 {{start}}–{{end}} 표시',
      },
      detail: {
        breadcrumb: {
          blog: '블로그',
        },
      },
    },
    spotlight: {
      index: {
        hero: {
          title_fallback: '스포트라이트',
          subtitle_fallback: 'AI 출시 소식, 비교, 실무 가이드를 빠르게 살펴보세요.',
        },
        seo: {
          title_fallback: 'Veeso 스포트라이트 | AI 비교와 실무 가이드',
          page_title: '{{title}} - {{page}}페이지 | Veeso',
          description_fallback:
            'AI 제품 출시, 도구 비교, 비주얼 제작팀을 위한 실무 가이드를 확인하세요.',
        },
        faq: {
          title_fallback: '자주 묻는 질문',
        },
        pagination: {
          prev: '← 이전',
          next: '다음 →',
          prev_aria: '이전 페이지로 이동',
          next_aria: '다음 페이지로 이동',
        },
        card: {
          read_more: '더 읽기',
        },
        author_alt_fallback: '작성자',
        image_alt_fallback: '스포트라이트 게시물 이미지',
        empty_state: '아직 스포트라이트 게시물이 없습니다.',
        min_read: '약 {{count}}분',
        showing_posts: '전체 {{total}}개 중 {{start}}–{{end}} 표시',
        page_aria: '{{page}}페이지로 이동',
      },
      detail: {
        breadcrumb: {
          spotlight: '스포트라이트',
        },
        seo_description_fallback: 'Veeso 스포트라이트에서 자세히 알아보세요.',
        image_alt_fallback: '게시물 이미지',
        video_title_fallback: 'YouTube 동영상',
      },
    },
    aiToolsIndex: {
      seo: {
        title: '빠르고 편집 가능한 AI 디자인 도구 | Veeso',
        description:
          '소셜, 마케팅, 비즈니스, 인쇄 콘텐츠를 만드는 Veeso AI 디자인 도구를 살펴보세요.',
        keywords: 'AI 디자인 도구, 편집 가능한 디자인, 마케팅 디자인, 비주얼 콘텐츠',
      },
      hero: {
        title: 'AI 디자인 도구',
        subtitle: '이미지가 아닌, 계속 편집할 수 있는 디자인을 만드세요.',
      },
      category: {
        social_media: '소셜 미디어',
        digital_marketing: '디지털 마케팅',
        business_print: '비즈니스 및 인쇄',
        stationery: '문구',
      },
      scroll: {
        left_aria: '왼쪽으로 스크롤',
        right_aria: '오른쪽으로 스크롤',
      },
      card: {
        fallback_title: 'AI 디자인 도구',
        cta: '생성기 사용',
      },
      empty_state: '아직 이용 가능한 콘텐츠가 없습니다.',
      seo_content: {
        hero: {
          title: 'Veeso AI를 선택해야 하는 이유',
          subtitle: '이미지 생성에서 멈추지 말고, 편집 가능한 디자인을 만드세요.',
        },
        compare: {
          traditional: {
            title: '기존 AI 이미지 도구',
            items: [
              '정적인 이미지',
              '콘텐츠 계층 구조 없음',
              '텍스트 수정이 어려움',
              '실제 게시용으로 부적합',
              '일회성 생성',
              '제한된 내보내기 형식',
              '편집에 디자인 기술 필요',
              '고정된 크기만 지원',
              '버전 관리 없음',
              '콘텐츠 길이에 맞춰 조정 불가',
              '다중 페이지 미지원',
              '편집에 많은 시간 소요',
              '브랜드 일관성 도구 없음',
            ],
          },
          veeso: {
            title: 'Veeso AI',
            items: [
              '구조화된 레이아웃',
              '명확한 정보 구조',
              '완전히 편집 가능한 레이어',
              '실제 게시를 위한 결과물',
              '자유로운 편집·개선·내보내기',
              '다양한 내보내기 형식',
              '콘텐츠 중심 워크플로',
              '디자인 기술 불필요',
              '유연한 크기',
              '반복적인 개선 지원',
              '콘텐츠에 맞춰 자동 조정',
              '다중 페이지 레이아웃 지원',
              '빠른 편집 워크플로',
              '브랜드 일관성 기능',
            ],
          },
        },
        steps: {
          title: '3단계로 디자인 만들기',
          1: {
            title: '콘텐츠 입력',
            description: '문구, 상품 설명, 행사 정보, 마케팅 카피를 붙여 넣으세요.',
          },
          2: {
            title: 'AI가 구조화된 레이아웃 생성',
            description: 'Veeso가 콘텐츠를 읽기 쉽고 균형 잡힌 레이아웃으로 구성합니다.',
          },
          3: {
            title: '자유롭게 편집하고 내보내기',
            description: '텍스트, 이미지, 레이아웃, 스타일을 조정한 뒤 필요한 형식으로 내보내세요.',
          },
        },
        audience: {
          title: '누구를 위한 도구인가요?',
          learn_more: '자세히 보기',
          marketers: {
            title: '마케터를 위한 도구',
            description: '디자인 기술 없이도 몇 분 만에 전문적인 마케팅 콘텐츠를 만드세요.',
          },
          hr: {
            title: '인사팀을 위한 도구',
            description: '채용 자료, 사내 공지 등 구성원이 주목하는 인사 콘텐츠를 만드세요.',
          },
          founders: {
            title: '창업자를 위한 도구',
            description: '디자인팀 없이도 브랜드를 구축하고 스타트업에 필요한 콘텐츠를 만드세요.',
          },
          creators: {
            title: '크리에이터를 위한 도구',
            description: 'YouTube 썸네일, Instagram 게시물처럼 눈에 띄는 콘텐츠를 만드세요.',
          },
          startups: {
            title: '스타트업을 위한 도구',
            description: '팀 규모를 늘리지 않고도 빠르게 전문 디자인 제작량을 확장하세요.',
          },
        },
        faq: {
          title: '자주 묻는 질문',
          items: [
            {
              question: 'Veeso AI란 무엇인가요?',
              answerParagraph1:
                '디자인 인력과 시간이 부족한 중소기업 운영자, 마케터, 실무 담당자, 창업자에게 전문적인 비주얼 제작은 느리고 비용이 많이 드는 일입니다.',
              answerParagraph2:
                'Veeso는 작성한 콘텐츠를 명확하고 완성도 높은 비주얼로 바꾸는 콘텐츠 중심 디자인 도구입니다. 디자인 기술 없이도 빠르게 결과물을 만들 수 있습니다.',
              answerParagraph3:
                '텍스트나 콘텐츠를 붙여 넣으면 다음과 같은 디자인을 만들 수 있습니다.',
              products: [
                '소셜 미디어 게시물',
                '포스터',
                '프레젠테이션',
                '캐러셀',
                '다중 페이지 브로슈어',
                '롱폼 콘텐츠',
                '레스토랑 메뉴',
                '초대장',
                '배너',
                '전단지',
                '앨범 커버',
              ],
            },
            {
              question: 'Veeso는 무료로 사용할 수 있나요?',
              answer:
                '네. Veeso의 AI 디자인 도구를 무료로 이용해 레이아웃을 생성하고 편집할 수 있습니다. 한곳에서 여러 디자인 생성기를 바로 살펴보고 제작을 시작할 수 있습니다.',
            },
            {
              question: 'Veeso는 다른 AI 디자인 도구와 무엇이 다른가요?',
              answerParagraph1:
                '많은 AI 디자인 도구는 수정하기 어려운 하나의 평면 이미지를 만듭니다.',
              answerParagraph2:
                'Veeso는 편집 가능한 텍스트, 섹션, 시각적 계층 구조를 갖춘 레이아웃을 만듭니다. 정적인 결과물에 갇히지 않고 수정하고 다듬어 실제 사용할 수 있는 디자인 파일로 내보낼 수 있습니다.',
              answerParagraph3:
                '단순한 이미지 실험이 아니라 실제 게시와 제작을 위해 설계되었습니다.',
            },
            {
              question: 'Veeso가 만든 디자인을 편집할 수 있나요?',
              answerParagraph1: '네. Veeso에서 생성한 모든 디자인은 편집할 수 있습니다.',
              answerParagraph2: '생성 후에도 디자인을 원하는 방식으로 세밀하게 조정할 수 있습니다.',
              listItems: [
                '텍스트 내용 수정',
                '레이아웃 블록 재배치',
                '이미지 교체',
                '간격과 구조 조정',
              ],
            },
            {
              question: '프롬프트를 작성해야 하나요?',
              answerParagraph1:
                '아니요. Veeso는 복잡한 프롬프트보다 사용자가 제공하는 콘텐츠를 중심으로 작동합니다.',
              answerParagraph2:
                '캡션, 상품 설명, 행사 정보를 붙여 넣으면 AI가 콘텐츠를 구조화된 레이아웃으로 자동 구성합니다.',
            },
            {
              question: 'Veeso는 템플릿을 사용하는 것보다 좋은가요?',
              answerParagraph1:
                '템플릿은 수동으로 내용을 맞추고 수정해야 하는 고정된 레이아웃입니다.',
              answerParagraph2:
                'Veeso는 입력한 콘텐츠에 맞춰 레이아웃을 동적으로 생성합니다. 텍스트 길이와 구조에 맞게 조정되므로 정적인 템플릿에서 시작하는 것보다 빠르고 유연합니다.',
            },
            {
              question: 'Veeso는 Canva의 대안인가요?',
              answerParagraph1:
                '네. 다만 Veeso는 템플릿 기반 편집기에 그치지 않고, 콘텐츠를 편집 가능한 디자인 파일로 바꾸는 구조화된 AI 레이아웃에 집중합니다.',
              answerParagraph2:
                '처음부터 디자인하는 작업을 줄이고 제작 속도를 높여 기존 디자인 도구와 함께 활용할 수도 있습니다.',
            },
            {
              question: 'Veeso는 비즈니스에 적합한가요?',
              answer:
                '네. Veeso는 전문적인 비주얼 콘텐츠를 빠르게 만들어야 하는 크리에이터, 마케터, 이커머스 판매자, 소규모 비즈니스를 위해 설계되었습니다.',
            },
          ],
        },
      },
    },
    aiToolsDetail: {
      breadcrumb: {
        tools: 'AI 디자인 도구',
      },
      fallback: {
        title: 'AI 디자인 도구',
      },
      generation_methods: {
        title_prefix: '세 가지 생성 방법',
        product_type_fallback: '소셜 미디어 게시물',
        section_product_fallback: '마케팅 콘텐츠',
      },
      choose_reasons: {
        cta: '무료로 사용해 보기',
      },
      use_cases: {
        title_fallback: 'Veeso AI로 전환 중심의 콘텐츠 구조를 만드세요.',
      },
      testimonials: {
        title_fallback: '{{audienceType}}이 Veeso AI를 선택하는 이유',
        audience_fallback: '마케팅팀',
      },
      how_to: {
        title_fallback: '성과를 내는 {{productType}} 만드는 방법',
        product_type_fallback: '마케팅 콘텐츠',
      },
      faq: {
        title: '자주 묻는 질문',
      },
      cta: {
        image_alt: '이미지가 아닌 편집 가능한 디자인 파일 만들기',
      },
      hero: {
        product_type_fallback: '마케팅 콘텐츠',
        design: '디자인 만들기',
        designing: '디자인 생성 중...',
      },
      loading: '콘텐츠를 불러오는 중...',
      explore_more: '더 많은 AI 디자인 활용 사례',
    },
  },
  languageSwitcher: {
    aria_label: '언어 선택',
  },
} as const;
